/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.FIREFOXOS_MODELS = {
  'ALCATEL ONE TOUCH FIRE': ['Alcatel', 'One Touch Fire'],
  'ALCATEL ONE TOUCH 4012A': ['Alcatel', 'One Touch Fire'],
  'ALCATEL ONE TOUCH 4012X': ['Alcatel', 'One Touch Fire'],
  'ALCATELOneTouch4012A!': ['Alcatel', 'One Touch Fire'],
  'ALCATELOneTouch4012X!': ['Alcatel', 'One Touch Fire'],
  OneTouch4019A: ['Alcatel', 'One Touch Fire C'],
  'ALCATELOneTouch4019A!': ['Alcatel', 'One Touch Fire C'],
  'ALCATELOneTouch4019X!': ['Alcatel', 'One Touch Fire C'],
  'ALCATELOneTouch4020D!': ['Alcatel', 'One Touch Fire C'],
  'ALCATELOneTouch4022!': ['Alcatel', 'One Touch Pixi 3 (3.5)'],
  'ALCATELOneTouch4023!': ['Alcatel', 'One Touch Pixi 3 (3.5)'],
  'ALCATELOneTouch6015X!': ['Alcatel', 'One Touch Fire E'],
  'HUAWEI Ascend Y300-F1': ['Huawei', 'Ascend Y300 F1'],
  'HUAWEIY300-F1': ['Huawei', 'Ascend Y300 F1'],
  'LG-D3(00|01)!': ['LG', 'Fireweb'],
  LGL25: ['LG', 'Fx0'],
  madai: ['LG', 'Fx0'],
  'Orange KLIF': ['Orange', 'Kilf'],
  'Orange KLIFD': ['Orange', 'Kilf'],
  OPEN: ['ZTE', 'Open'],
  ZTEOPEN: ['ZTE', 'Open'],
  OpenC: ['ZTE', 'Open C'],
  'Open C': ['ZTE', 'Open C'],
  OPENC2: ['ZTE', 'Open C2'],
  OPEN2: ['ZTE', 'Open II'],

  'ALCATEL4044[MNOTVW]!': ['Alcatel', 'Go Flip'],
  'ALCATEL4044C!': ['Alcatel', 'QUICKFLIP'],
  '.LYF/.F30C!': ['Jio', 'JioPhone F30C'],
  '.LYF/.F101K!': ['Jio', 'JioPhone F101K'],
  'LYF/F30C!': ['Jio', 'JioPhone F30C'],
  'LYF/F41T!': ['Jio', 'JioPhone F41T'],
  'LYF/F50Y!': ['Jio', 'JioPhone F50Y'],
  'LYF/F61F!': ['Jio', 'JioPhone F61F'],
  'LYF/F81E!': ['Jio', 'JioPhone F81E'],
  'LYF/F90M!': ['Jio', 'JioPhone F90M'],
  'LYF/F101K!': ['Jio', 'JioPhone F101K']
};

/* This file is automatically generated, do not edit manually! */
